import React from 'react';

import StyledProcessingSpinner from './Styled';

const ProcessingSpinner = ({ size = 4, color = 'primary', ...props }) => (
  <StyledProcessingSpinner borderColor={color} size={size} {...props} />
);

export default ProcessingSpinner;
